import { NotificationReducer } from '@elotech/components';
import { combineReducers } from 'redux';
import {
  AuthReducer,
  EntidadeReducer,
  KeycloakReducer,
  ProcessosAgrupadosReducer
} from 'state/reducers';

export const rootReducer = (config = {}, configExterna = {}) => {
  const ConfigReducer = () => config;
  const ConfigExternaReducer = () => configExterna;

  return combineReducers({
    auth: AuthReducer,
    config: ConfigReducer,
    configExterna: ConfigExternaReducer,
    entidade: EntidadeReducer,
    notification: NotificationReducer,
    processosAgrupados: ProcessosAgrupadosReducer,
    user: KeycloakReducer
  });
};
